import {
  END_VOICE_CALL_ACTION,
  ERROR_END_VOICE_CALL_ACTION,
  MULTIMEDIA_CATEGORY,
} from '~/constants/analytics'
import analytics from '~/core/analytics'
import { useEventBus } from '~/core/event-bus'
import { CallStep } from '~/generated'

import useReportCallStep from '../useReportCallStep'

const trackEvent = analytics.trackEventFactory({
  category: MULTIMEDIA_CATEGORY,
})

const useEndVoiceCallMutation = (consultationId: string) => {
  const [reportCallStep, result] = useReportCallStep(consultationId)
  const eventBus = useEventBus()

  const performMutation = async () => {
    try {
      await reportCallStep(CallStep.VoiceCallEndedByClinician)

      eventBus.emit('AUDIO_CALL_ENDED')
      trackEvent({ action: END_VOICE_CALL_ACTION })

      return true
    } catch (exception) {
      trackEvent({ action: ERROR_END_VOICE_CALL_ACTION })
      throw exception
    }
  }

  return [performMutation, result] as const
}

export default useEndVoiceCallMutation
